export default "__VITE_ASSET__y9fDbSIf__"